import { useQuery } from '@tanstack/react-query';
import { getMagentaDiscount } from '@/api/magentaTv/getMagentaDiscount';
import { MagentaDiscountResponse } from '@/api/magentaTv/getMagentaDiscount';

export const useGetMagentaDiscount = (enabled = true) => {
  const { data, isLoading, isError, error, status } = useQuery<MagentaDiscountResponse>({
    queryKey: ['magentaDiscount'],
    queryFn: getMagentaDiscount,
    enabled,
    useErrorBoundary: false,
  });

  return {
    initializing: isLoading || isError,
    data,
    isError,
    error,
    status,
  };
};
